import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { LogicContext } from '../types';

export const watchSessionTokenExpirationTime = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'REFRESH_SESSION_TOKEN';
        data?: {
          access_token: string;
        };
      }>
    ) => {
      /*
       * fetching auth token from the Data Gateway service
       */
      let intervalId: ReturnType<typeof setInterval>;

      const {
        user: { authToken },
      } = context;
      const expirationTime = authToken?.expires_in; // value from the API (in seconds)

      const intervalTime = (expirationTime?: number) => {
        const defaultInterval = 300000; // 5 min
        const interval =
          expirationTime && Number.isInteger(expirationTime)
            ? expirationTime * 1000 - 1000 * 60
            : defaultInterval; // the expiration time from CAS minus 1 minute or deafult 5 min
        return interval > 0 ? interval : defaultInterval;
      };

      intervalId = setInterval(async () => {
        callback({
          type: 'REFRESH_SESSION_TOKEN',
        });
      }, intervalTime(expirationTime));

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }
  );
